import React, { FC, useEffect } from 'react';

import { ValidatedInput } from '../../validated-input';

import { kgValidationQuery } from './kg-validation-query';

import i18n from 'i18next';

const props = { label: i18n.t('weight'), maxLength: 3 };

const LABEL = i18n.t('kg');

type KgInputProps = {
    value: string;
    onChange: (e: any) => void;
    onError: (error: boolean, key: string) => void;
    lessThen?: number;
    autoFocus?: boolean;
    withEndAdornment?: boolean;
};

export const KgInput: FC<KgInputProps> = ({
    value,
    onChange,
    onError,
    autoFocus,
    withEndAdornment = true,
}) => {

    const handleError = (key: string) => (error: boolean) => onError(error, key);

    useEffect(() => () => onError(false, LABEL), []);

    const endAdornmentLabel = withEndAdornment ? LABEL : '';

    const validationQuery = JSON.parse(JSON.stringify(kgValidationQuery));

    return (
        <ValidatedInput
            type="number"
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            onError={handleError(LABEL)}
            validationQuery={validationQuery}
            endAdornment={endAdornmentLabel}
            {...props}
        />
    );
};
